import React from 'react';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { filterAvailServices } from '../../../store/avail/availServicesActions';
import { compose } from 'ramda';
import styleFile from './StepCursor.js';
import connect from 'react-redux/es/connect/connect';

class StepCursor extends React.Component {
  static displayName = 'StepCursor';
  render() {
    const { theme, config } = this.props;
    const { classes } = theme.styles;
    const { currentStep, availServices, reservationBlocks,stepMonoPosition } = config;
    let hasServices = false;
    if (availServices && reservationBlocks) {
      hasServices = filterAvailServices(availServices.get('services'), reservationBlocks).size;
    }
    let stepClass = theme.styleGetter();
    if (currentStep >= (stepMonoPosition + 1)) {
      stepClass = theme.styleGetter(classes.staP2);
    }
    
    if (currentStep === (stepMonoPosition + 2)) {
      stepClass = theme.styleGetter([classes.staP2, classes.staP3]);
    }

    const stepCursor = (
      <div className={stepClass}>
        <div className={classes.maxContainer}>
          <div className={classes.stepContainer}>
            <ul className={classes.stepContent}>
              <li className={classes.step} />
              {!!hasServices && <li className={classes.step} />}
              <li className={classes.step} />
            </ul>
          </div>
        </div>
      </div>
    );

    return currentStep >= stepMonoPosition && currentStep <= (stepMonoPosition + 2) ? stepCursor : null;
  }
}

const mapStateToProps = store => {
  const hotelId = store.getIn(['customer', 'current_hotel']);

  const availServices = store.getIn([
    'availServices',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', 'string_service_query_params']),
    'response'
  ]);

  var stepMonoPosition = store.getIn(['customer', 'step', 'list'])
    .find((step) => step.get("code") === "monoHotelAvail")
    .get("position");

  const reservationBlocks = store.getIn(['customer', 'reservation_request', 'blocks']);

  return {
    reservationBlocks: reservationBlocks,
    availServices: availServices,
    currentStep: store.getIn(['customer', 'step', 'current_step', 'position']),
    stepMonoPosition
  };
};

export default compose(
  connect(mapStateToProps),
  PropertyManager(['currentStep', 'reservationBlocks', 'availServices','stepMonoPosition']),
  withThemeJSS({ styleFile, link: true })
)(StepCursor);
